import React from 'react';
import { placeholderImages } from '../utils/placeholders';

const Footer: React.FC = () => {
  return (
    <footer id="footer">
      <div className="inner">
        <div className="footer-content">
          {/* Social Icons - Centrados */}
          <ul className="footer-icons">
            <li>
              <a 
                href="https://www.instagram.com/geemaa_rg/" 
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                title="Sígueme en Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a 
                href="https://www.tiktok.com/@geemaa_rg" 
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                title="Sígueme en TikTok"
              >
                <i className="fab fa-tiktok"></i>
              </a>
            </li>
            <li>
              <a 
                href="https://www.linkedin.com/in/gema-ruiz-gordillo-5931a0313/" 
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                title="Conecta en LinkedIn"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
          </ul>

          {/* Copyright - Centrado */}
          <div className="footer-copyright">
            <p>&copy; 2025 Gema Ruiz - Todos los derechos reservados</p>
          </div>

          {/* Logo VCOF - Centrado */}
          <div className="footer-logo-container">
            <a 
              href="https://www.voguecollege.com/es/" 
              target="_blank" 
              rel="noopener noreferrer"
              title="Visitar Vogue College of Fashion"
              className="footer-logo-link"
            >
              <img 
                src={placeholderImages.vcof} 
                alt="VCOF Logo" 
                className="footer-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
